import { ICaremapNote } from './NotesClient';
import { FileUploader } from '../generic-notes/attachments/FileUploader';

export class NoteValidator {
    static inject = () => [FileUploader];
    constructor(private fileUploader: FileUploader){

    }
    isValid = (note: ICaremapNote): boolean => {
        const hasOneOfRequiredFields = Boolean(note.html) || Boolean(note.title) || note.attachments.length > 0;
        return this.fileUploader.getUploadingCount() === 0 && hasOneOfRequiredFields;
    };
}
